import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { SubstitutionsApi } from "../../../api/substitutions";
import { QueryKey } from "../../../consts/query-keys";

export const useSubstitutions = (datasetId?: number) => {
  const [searchParams] = useSearchParams();

  const { data, isPending, refetch } = useQuery({
    queryKey: [QueryKey.Substitutions, datasetId],
    enabled: !!datasetId,
    queryFn: () => SubstitutionsApi.list({ path: { datasetId: datasetId! } }),
  });

  const search = searchParams.get("search")?.toLowerCase() ?? "";

  const filtered = useMemo(() => {
    const rows = data?.Substitutions ?? [];
    if (!search) return rows;
    return rows.filter(r => {
      const dataset = (r.DatasetName ?? "").toLowerCase();
      const ids = [
        r.OriginalInputId,
        r.OriginalPlantId,
        r.ReplacementInputId,
        r.ReplacementPlantId,
      ]
        .filter(Boolean)
        .map(v => String(v))
        .join(" ");
      const names = [
        r.OriginalInputName,
        r.OriginalPlantName,
        r.ReplacementInputName,
        r.ReplacementPlantName,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return (
        dataset.includes(search) ||
        ids.includes(search) ||
        names.includes(search)
      );
    });
  }, [data, search]);

  return { substitutions: filtered, isPending, refetch };
};
